import zhCN from './zh-CN';
import zhTW from './zh-TW';
import enUS from './en-US';
import esES from './es-ES';

const localesMap = {
  "zh-CN": zhCN,
  "zh-TW": zhTW,
  "en-US": enUS,
  "es-ES": esES
};

export default localesMap;